module.exports = __webpack_public_path__ + "static/media/Fun88_Affiliate_logo_TH.ac80f6f8.webp";